export default __webpack_public_path__ + "static/gumroad-38cfe2eb8971bb00cb4b7b2a9dcc0c73.svg";